export const LANGUAGE_LOCAL_STORAGE_KEY = "mp_language";
